import React from 'react';
export const TrustedBy = () => {
  const partners = [{
    name: 'BE Labs',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rz8TZat77kxpjqLhFLM5fx/BE_Labs.png'
  }, {
    name: 'Craig Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ntTF4CDfLTXz8WATTfepgn/Craig_Group.png'
  }, {
    name: 'Gleantap',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/b3im3xK8HfWSUpUZoF3rC1/Gleantap.png'
  }, {
    name: 'KENTECH',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jFVATaxBjLzmHvYRzAJ2AK/KENTECH_copy.png'
  }, {
    name: 'Innervate',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bokQLKvM4Qf41iQQ3fX49e/Innervate.png'
  }, {
    name: 'eKnowID',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5sfib6zZyMh7Nw5ECy2USo/eknowid.png'
  }, {
    name: 'mniche',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nu6hkUhm2MZyMAewKZpeeY/mniche_logo_Transparent.png'
  }];
  return <section className="py-10 bg-purple-50 relative overflow-hidden" data-id="element-779">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-780">
        <div className="flex overflow-hidden relative w-full max-w-5xl mx-auto" data-id="element-781">
          <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-purple-50 to-transparent z-10 pointer-events-none" data-id="element-782"></div>
          <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-purple-50 to-transparent z-10 pointer-events-none" data-id="element-783"></div>

          <div className="flex animate-marquee whitespace-nowrap w-max" data-id="element-784">
            <div className="flex items-center justify-around gap-8 md:gap-16 px-4 md:px-8" data-id="element-785">
              {partners.map((partner, index) => <div key={`first-${index}`} className="flex items-center opacity-50 hover:opacity-80 transition-opacity shrink-0" data-id="element-786">
                  <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-8 md:max-h-10 filter grayscale" style={{
                maxWidth: '120px'
              }} data-id="element-787" />
                </div>)}
            </div>
            <div className="flex items-center justify-around gap-8 md:gap-16 px-4 md:px-8" data-id="element-788">
              {partners.map((partner, index) => <div key={`second-${index}`} className="flex items-center opacity-50 hover:opacity-80 transition-opacity shrink-0" data-id="element-789">
                  <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-8 md:max-h-10 filter grayscale" style={{
                maxWidth: '120px'
              }} data-id="element-790" />
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};